<ion-grid *ngIf="!!selection.menuModifierSelection && selection.menuModifierSelection.maxCount === 1; else useModal">
    <ion-row>
        <ion-col>
            <span [class.title]="!child">{{ selection.menuModifierSelection.name }}</span>
            <ion-text class="required"
                    *ngIf="selection.menuModifierSelection.required && (!selectedOptions || selectedOptions.length < selection.menuModifierSelection.minCount)"
                    color="danger">Required
            </ion-text>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col>
            <ion-segment [scrollable]="true"
                         [(ngModel)]="selectedOption" mode="ios" (ionChange)="selectionChange()">
                <ion-segment-button *ngFor="let option of options" [value]="option"
                                    class="modifier-selection-option">
                    <ion-label>
                        {{ option.menuModifier.name }}
                        <p *ngIf="!!option.additionalPrice">
                            {{ option.additionalPrice | currency }}
                        </p>
                    </ion-label>
                </ion-segment-button>
                <ion-segment-button *ngIf="!selection.menuModifierSelection.required" [value]="'none'"
                                    class="modifier-selection-option">
                    <ion-label>
                        No Modifier
                    </ion-label>
                </ion-segment-button>
            </ion-segment>
        </ion-col>
    </ion-row>
</ion-grid>

<ng-template #useModal>
    <ion-item [button]="true" [detail]="false" (click)="openModal = true" [lines]="lines">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-label>
                        <span [class.title]="!child">{{ selection.menuModifierSelection.name }}</span>
                        <p>
                            <ion-text color="secondary">{{ selectionMessage }}</ion-text>
                        </p>
                        <p *ngIf="!selectedOptions || selectedOptions.length === 0" class="modifier-info">
                            No Modifier
                        </p>
                        <p *ngFor="let modifier of selectedOptions" class="modifier-info">
                            {{ modifier.menuModifier.name }}
                            <ng-container *ngIf="modifier.additionalPrice">({{ modifier.additionalPrice | currency }})</ng-container>
                        </p>
                    </ion-label>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-item>

    <ion-modal *ngIf="openModal"
               [isOpen]="openModal"
               css-class="menu-modal"
               (didDismiss)="openModal = false">
        <ng-template>
            <modal-header title="{{selection.menuModifierSelection.name}}" [subHeader]="selectionMessage"></modal-header>
            <ion-content class="ion-padding">
                <bb-select-buttons [options]="selection.options"
                                   [selected]="selectedOptions"
                                   [sizeLg]="4"
                                   [sizeXl]="3"
                                   [sizeSm]="6"
                                   (optionSelected)="multiSelectionChange($event)">
                    <ng-template let-option #displayTemplate>
                        <ion-grid>
                            <ion-row>
                                <ion-col class="ion-text-center">{{ option.menuModifier.name }}</ion-col>
                            </ion-row>
                            <ion-row *ngIf="!!option.additionalPrice">
                                <ion-col class="ion-text-center">{{ option.additionalPrice | currency }}</ion-col>
                            </ion-row>
                        </ion-grid>
                    </ng-template>
                </bb-select-buttons>
            </ion-content>
            <ion-footer class="ion-no-border">
                <ion-button color="dark" class="footer-button" (click)="this.openModal = false">
                    Done
                </ion-button>
            </ion-footer>
        </ng-template>
    </ion-modal>
</ng-template>
